import React from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute, AdminRoute } from '@providers';

/**
 * Layout wrapper for admin screens.
 *
 * Renders a marker element (`data-admin-layout`) that CSS uses to override
 * `--app-max-width` on `#app`, letting admin screens use the full viewport
 * width instead of the 640px mobile constraint.
 *
 * Admin screens manage their own headers/footers — this layout provides no
 * chrome, only the auth guards and the width override.
 */
export const AdminLayout: React.FC = () => (
  <ProtectedRoute>
    <AdminRoute>
      <div data-admin-layout className="flex flex-col flex-1 min-h-0">
        <Outlet />
      </div>
    </AdminRoute>
  </ProtectedRoute>
);
